import { BasicTable, ContentLoader, BasicTableRowsProps, Typography } from '@dev/ee-components';
import { map, isEmpty } from 'lodash-es';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getAutomationStore } from '@/store/automations/actions';
import { DEFAULT_PER_PAGE_COUNT } from '@/services/constants';

const useTableRows = (): BasicTableRowsProps[] => {
    const { loadingContactsList, contactsList, contactsListPagination } = useSelector(getAutomationStore);

    if (loadingContactsList) {
        const perPage = contactsListPagination?.perPage || DEFAULT_PER_PAGE_COUNT;
        const rows: BasicTableRowsProps[] = [];

        for (let index = 0; index < perPage; index++) {
            rows?.push({
                email: <ContentLoader mode="row" height={20} />,
            });
        }

        return rows;
    }

    return map(
        contactsList,
        (singleContact: string): BasicTableRowsProps => ({
            email: <Typography variant="caption">{singleContact}</Typography>,
        })
    );
};

const ContactsTable: FC = (): JSX.Element => {
    const { loadingContactsList, contactsList } = useSelector(getAutomationStore);
    const { t } = useTranslation();
    const headers = [{ id: 'email', label: t('email') }];

    return (
        <BasicTable
            headers={headers}
            rows={useTableRows()}
            isEmpty={isEmpty(contactsList) && !loadingContactsList}
            stickyHeader
            disableHover
        />
    );
};

export default ContactsTable;
